import type { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import { cn } from '@/lib/utils';
import { SOFT_BLUE_GRADIENT_CLASS } from '@/styles/softBlueSurface';
import { formatNumber } from '@/utils/number';

const HERO_SURFACE_CLASS = cn(
  'flex flex-wrap items-start justify-between gap-4 rounded-2xl p-4 ring-1 ring-primary/12 sm:p-5',
  SOFT_BLUE_GRADIENT_CLASS,
);
const AMOUNT_LABEL_CLASS = 'text-2xs font-medium tracking-wider text-muted-foreground uppercase';

interface DetailHeroProps {
  heading: ReactNode;
  subline: ReactNode;
  amountLabel: string;
  amount: number | undefined;
  amountNote: ReactNode;
  amountUnit?: string | undefined;
}

export function DetailHero({
  heading,
  subline,
  amountLabel,
  amount,
  amountNote,
  amountUnit = TAKA_SYMBOL,
}: DetailHeroProps) {
  return (
    <div className={HERO_SURFACE_CLASS}>
      <div className="flex min-w-0 flex-col gap-2">
        {heading}
        {subline}
      </div>

      <div className="flex flex-col items-start gap-1 text-left">
        <span className={AMOUNT_LABEL_CLASS}>{amountLabel}</span>
        {amount === undefined ? (
          <Skeleton className="h-9 w-28" />
        ) : (
          <span className="text-3xl leading-none font-bold tracking-tight tabular-nums">
            {formatNumber(amount)}
            <span className="ml-1 text-base font-semibold text-muted-foreground">{amountUnit}</span>
          </span>
        )}
        {amountNote}
      </div>
    </div>
  );
}
